(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
panel: this.querySelector('ul'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

hidePanel() {
this.elements.button.setAttribute('aria-expanded', 'false');
this.elements.panel.setAttribute('hidden', true);
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.hidePanel();
this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
this.elements.input.value = event.currentTarget.dataset.value;
this.querySelector('form')?.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.panel.toggleAttribute('hidden');
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
if (event.relatedTarget === null || shouldClose) {
this.hidePanel();
}
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerWrapper = document.querySelector('.header-wrapper')
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

//if (this.headerIsAlwaysSticky) {
//this.header.classList.add('shopify-section-header-sticky');
//this.header.classList.add('always-fixed');
//};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.searchOverlay = document.querySelector('.search-modal__overlay');

	if (this.searchOverlay) {
		this.searchOverlay.addEventListener('click', function(){
			const searchModal = document.querySelector('details-modal');
			searchModal.close();
		})
	}

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 50) {
	this.header.classList.add('shopify-section-header-sticky');
};

if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight / 2) {
	this.header.classList.remove('shopify-section-header-sticky');
};
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
}else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
class CartNote extends HTMLElement {
	constructor() {
		super();

		this.addEventListener('change', debounce((event) => {
			const body = JSON.stringify({note: event.target.value});
			fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{body}});
		}, 300))
	}
}

customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();

		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (document.querySelector('.steps-section')) {
              ScrollTrigger.getAll().forEach((el) => el.kill());

              const setStepsParallaxOpt = (elem) => {
                elem.setAttribute('data-parallax-property-value', '-40');
                elem.setAttribute('data-parallax-steps', '0, 40');
                elem.setAttribute('data-parallax-property', 'translateY');
              };

              const removeStepsParallaxOpt = (elem) => {
                elem.removeAttribute('data-parallax-property-value');
                elem.removeAttribute('data-parallax-steps');
                elem.removeAttribute('data-parallax-property');
                elem.removeAttribute('style');
              };

              const calcDurationScroll = (elem) => {
                switch (elem.length) {
                  case 1:
                    return 'bottom bottom';
                  case 2:
                    return '+=80%';
                  case 3:
                    return '+=140%';
                  case 4:
                    return '+=180%';
                  case 5:
                    return '+=200%';
                }
              };

              const initStepsParallax = () => {
                const stepsSections = document.querySelectorAll('.steps-section');

                stepsSections.forEach((elem) => {
                  const parallax = elem.querySelectorAll('.steps__scroll-parallax');

                  parallax.forEach((elem) => {
                    if (window.matchMedia('(min-width: 990px)').matches) {
                      elem.classList.add('js-parallax');
                      setStepsParallaxOpt(elem);
                    } else {
                      elem.classList.remove('js-parallax');
                      removeStepsParallaxOpt(elem);
                    }
                  });
                });
              };

              const initStepsAnim = () => {
                const containers = document.querySelectorAll('.steps');

                containers.forEach((elem) => {
                  ScrollTrigger.matchMedia({
                    '(min-width: 990px)': function () {
                      const slides = elem.querySelectorAll('.steps__slide-item--desktop');
                      let parallax = elem.querySelector('.steps__scroll');
                      let progress = [];

                      slides.forEach((elem, index) => {
                        progress.push((1 / slides.length) * index - 1 / slides.length / 2);
                      });

                      progress.push(1);

                      const removeActiveClass = () => {
                        slides.forEach((elem) => {
                          elem.classList.remove('active');
                        });
                      };

                      let st = ScrollTrigger.create({
                        trigger: elem,
                        start: 'top top',
                        end: calcDurationScroll(slides),
                        invalidateOnRefresh: true,
                        animation: parallax
                          ? gsap.fromTo(parallax, { y: 0 }, { y: -(parallax.scrollHeight - elem.clientHeight + 310) })
                          : false,
                        pin: true,
                        scrub: 0.5,
                        onRefresh: (self) => {
                          for (let i = 0; i <= slides.length; i++) {
                            if (self.progress > progress[i] && self.progress < progress[i + 1]) {
                              removeActiveClass();
                              slides[0].classList.remove('active');
                              slides[i].classList.add('active');
                              slides[i].classList.remove('prev');
                            }
                          }
                        },
                        onUpdate: (self) => {
                          for (let i = 0; i <= slides.length; i++) {
                            if (self.progress > progress[i] && self.progress < progress[i + 1]) {
                              if (!slides[i].classList.contains('active')) {
                                removeActiveClass();
                                slides[i].classList.add('active');
                                slides[i].classList.remove('prev');

                                for (let el of slides) {
                                  if (el.classList.contains('active')) break;
                                  el.classList.add('prev');
                                }
                              }
                            }
                          }
                        },
                      });
                    },
                    '(max-width: 989px)': function () {
                      if (elem.querySelector('.steps__scroll') !== null) {
                        elem.querySelector('.steps__scroll').style.transform = 'translate3d(0, 0, 0)';
                        ScrollTrigger.getAll().forEach((el) => el.kill());
                      }
                    },
                  });
                });
              };

              setTimeout(() => {
                initStepsAnim();
                initStepsParallax();
              }, 300);
            }
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
